$(document).ready(function(){
//   $(document).on('click', '.toggle', function(e) {
//     e.preventDefault();
//     let $this = $(this);
//     if ($this.next().hasClass('show')) {
//         $this.next().removeClass('show');
//         $this.next().slideUp(350);
//     } else {
//         $this.parent().parent().find('li .inner').removeClass('show');
//         $this.parent().parent().find('li .inner').slideUp(350);
//         $this.next().toggleClass('show');
//         $this.next().slideToggle(350);
//     }
//   });

  // $('.product__media-list').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   infinite: false,
  //   asNavFor: '.thumbnail-list',
  //   prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//blackeyewear.com/cdn/shop/t/23/assets/arrow--left.svg?v=35244841151725471841766143929'/></button>",
  //   nextArrow:"<button type='button' class='slick-next pull-right'><img src='//blackeyewear.com/cdn/shop/t/23/assets/arrow--right.svg?v=132318986623443259491766143929'/></button>"
  // });

  // $('.thumbnail-list').slick({
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   asNavFor: '.product__media-list',
  //   vertical: true,
  //   verticalSwiping: true,
  //   focusOnSelect: true,
  //   infinite: false,
  // });

  $('.collection-title__flex label').click(function(){
    var swatch = $(this).data('swatch');

    $('.collection--wrapper .collection--grid').removeClass('active').addClass('hide');;
    $('.collection--wrapper .collection--grid[data-swatch="' + swatch + '"]').removeClass('hide').addClass('active');

    $('.collection-title__flex .collection__swatch p').removeClass('active').addClass('hide');
    $('.collection-title__flex .collection__swatch p[data-swatch="' + swatch + '"]').removeClass('hide').addClass('active');

  });

  // $(document).on("click", "cart-remove-button", function(e){
  //   e.preventDefault();
  //   var id = $(e.target).closest("tr").attr('data-main');
  //   var target = $(e.target).closest("tr");
  //   var item = $(e.target).closest("tr").attr("id");
  //   var first = $(e.target).closest("tr").data("line");
  //   var second = $("tr[data-product-for='" + id + "']").first().data("line");
  //   var third = $("tr[data-product-for='" + id + "']").eq(1).data("line");
  //   var fourth = $("tr[data-product-for='" + id + "']").eq(2).data("line");

  //   console.log(id);

  //   console.log(first + ' ' + second + ' ' + third + ' ' + fourth);

  //   var data = { updates: {} };
  //   data.updates[first] = 0;

  //   if(second != undefined) {
  //     data.updates[second] = 0;
  //   }
  //   if(third != undefined) {
  //     data.updates[third] = 0;
  //   }
  //   if (fourth != undefined ) {
  //     data.updates[fourth] = 0;
  //   }

  //   $.ajax({
  //     type: 'POST',
  //     url: window.Shopify.routes.root + 'cart/update.js',
  //     data: data,
  //     dataType: 'json',
  //     success: function(cart) {
  //       var total = cart.total_price / 100;
  //       target.hide();
  //       if(cart.item_count != 0) {
  //         $('.totals__subtotal-value').text(theme.moneyFormat + total.toFixed(2));
  //       } else {
  //         $('.cart-count-bubble').remove();
  //         $('.totals__subtotal-value').text(theme.moneyFormat + '0.00');
  //       }
  //     },
  //     error: function(err){
  //     }
  //   });
  // });

  if($('.cart-item[data-pos="main"]').length > 0) {
    $('.cart-count-bubble span').text($('.cart-item[data-pos="main"]').length);
  } else {
    $('.cart-count-bubble').remove();
  }


  $('div#shopify-section-announcement-bar').slick({
    arrows: false,
    autoplay: true,
    infinite: true
  });

  $("button[data-tab='tabcontent-1']").click(function(){
    $(".image-with-text.st-albans").removeClass("hide");
    $(".image-with-text.london").addClass("hide");
  });

  $("button[data-tab='tabcontent-2']").click(function(){
    $(".image-with-text.st-albans").addClass("hide");
    $(".image-with-text.london").removeClass("hide");
  });

  $(".thumbnail-list__item").click(function(){
    var color = $(this).data("variant");
    $(".color-swatch-item[data-color='" + color + "']").click();
    $(".color-swatch-item").removeClass("toClick");
    $(".color-swatch-item").removeClass("noClick");
  })


  $(".product .slider-button").click(function(){

      var color = $(".thumbnail[aria-current]").parent().next("[data-variant]").data("variant");
      if (typeof color === 'undefined' || typeof color === undefined || typeof color === "" || color === null) {

      } else {
        console.log(color);

        $(".color-swatch-item").addClass("noClick");
        $(".color-swatch-item[data-color='" + color + "']").addClass("toClick");

      }
  })
});




